var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.001,
    y1: 0.501,
    x2: 0.999,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.999,
    y1: 0.501,
    x2: 0.001,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#f6d0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#f5cca5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#f4c8a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#f3c49c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#f2c197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#f1bd92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#f1b98d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#f0b689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#efb384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#eeb081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#eead7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#eeab7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#edaa78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a5a2a",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#995a2a",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#985929",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#955728",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#925527",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#8e5225",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#8a4f23",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#854c21",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#80491e",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7b451c",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#774219",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#723f17",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#6f3d15",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#6d3c14",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c3b13",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#f7d3ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#f6d2ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#f6d0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#f5cda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#f4c9a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#f3c49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#f2bd93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#efb587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff000f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fe010f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#fb0210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f60410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#f00511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#e90511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e10612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#da0713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#d20814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page-not-found",
    transform: "translate(-575 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PageNotFound",
    transform: "translate(575 46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M212.4,206.344c25.625-20.156,46.875-55.6,43.177-86.663-3.7-31.127-32.291-57.816-57.916-74.15s-48.177-22.313-70.051-21.45c-21.823.925-42.969,8.568-67.969,24.9l-1.5.991C33.5,66.32,5.691,90.958.791,121.16c-4.948,30.881,13.958,67.679,38.958,87.772,24.75,19.954,55.472,23.6,85.647,23.01l.914-.019C156.831,231.307,186.779,226.5,212.4,206.344Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M129.5,218.677c3.261,0,3.261,5.017,0,5.017C126.3,223.694,126.235,218.677,129.5,218.677Zm-74.851-11.3a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,54.645,207.381Zm132.25-4.822c3.261,0,3.261,5.017,0,5.017C183.7,207.576,183.634,202.559,186.9,202.559ZM70.3,200.643c3.261,0,3.261,5.017,0,5.017C67.105,205.66,67.105,200.643,70.3,200.643Zm30.038-3.449a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,100.342,197.194ZM58.019,160.82a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,58.019,160.82ZM241.505,159a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,241.505,159ZM13.492,152.667a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,13.492,152.667Zm215.123-1.76a1.569,1.569,0,0,1,0,3.135A1.569,1.569,0,0,1,228.615,150.907Zm-92.832-1.85a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,135.783,149.057Zm33.866.467a.627.627,0,0,1,0,1.254A.627.627,0,0,1,169.649,149.524Zm-45.46-.78a.627.627,0,0,1,0,1.254A.627.627,0,0,1,124.189,148.744ZM38.762,140.43a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,38.762,140.43Zm134.022-.3a1.569,1.569,0,0,1,0,3.135A1.569,1.569,0,0,1,172.784,140.125Zm-39.509,1.551a.628.628,0,0,1,0,1.255A.628.628,0,0,1,133.275,141.676ZM63.389,130.452c3.261,0,3.261,5.017,0,5.017C60.191,135.469,60.191,130.452,63.389,130.452Zm177.753-.048c3.261,0,3.261,5.017,0,5.017C237.944,135.421,237.881,130.4,241.142,130.4Zm-31.357-8.748c3.261,0,3.261,5.017,0,5.017C206.587,126.673,206.524,121.656,209.785,121.656ZM62.95,93l.033.014c.839.823-31.365,31.872-32.027,32.478a1.714,1.714,0,0,1-2.43,0,1.613,1.613,0,0,1,0-2.379l7.282-6.644C45.578,107.6,61.95,92.885,62.95,93ZM9.505,117.6a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,9.505,117.6Zm49.14-4.131a.628.628,0,0,1,0,1.255A.628.628,0,0,1,58.646,113.471Zm173.716-2.508a.627.627,0,0,1,0,1.254A.627.627,0,0,1,232.362,110.963ZM155.505,106a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,155.505,106Zm-8.433-6.012a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,147.072,99.988ZM26.759,98c3.261,0,3.261,5.017,0,5.017C23.561,103.017,23.561,98,26.759,98Zm135.663-3c3.261,0,3.261,5.017,0,5.017C159.224,100.017,159.161,95,162.422,95ZM105.7,83.369a.627.627,0,0,1,0,1.254A.627.627,0,0,1,105.7,83.369ZM90,67.514a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,90,67.514ZM76.505,54a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,76.505,54Zm41.917-9c3.261,0,3.261,5.017,0,5.017C115.224,50.017,115.161,45,118.422,45Zm48.718,3.249a.627.627,0,0,1,0,1.254A.627.627,0,0,1,167.14,48.249Zm-4.39-7.839a1.569,1.569,0,0,1,0,3.136A1.569,1.569,0,0,1,162.75,40.41Zm-30.1-9.093a.627.627,0,0,1,0,1.254A.627.627,0,0,1,132.648,31.317Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(34 31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M65.5,32.326,60.725,26.8l7.863-6.243,4.2,5.171Z",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M10.88,44.476l2.59-10.145,6.092,2.4L15.63,46.247Z",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M74.058,89.393,63.474,131.98c-8.892,7.192-22.763-9.947-19.994,0a61.905,61.905,0,0,1,.45-35.955l8.327-26.253a5,5,0,0,0-2.548-5.993L14.95,46.578l4.792-11.951,47.466,20.2a9.643,9.643,0,0,1,5.851,8.3L74.2,87.958A5,5,0,0,1,74.058,89.393Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M54.7,147.028A25.77,25.77,0,0,1,43.48,131.98,27.361,27.361,0,0,1,52.624,103.4L85.708,76.629a5,5,0,0,0,1.144-6.457L64.037,32.1l9.683-7.488,32.922,42.557a11.848,11.848,0,0,1,.5,13.8L80.618,120.884l-8.5,31.8-.731-.1c-2.5-.366-8.016-1.335-11.814-3.179A24.513,24.513,0,0,1,54.7,147.028Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M126.849,118.781v-8.365l.712-1.089a89.172,89.172,0,0,0,5.158-9.059c2.321-4.849,5.3-15.945,9.445-18.406l.227-.125c4.26-2.18,7.985-11.85,8.4-14.281.4-2.38-5.454-.768-6.219-.119l-.04.038c-.552.607-5.1,2.205-6.4,6.484l-.086.3c-1.452,5.57-12.172,14.832-21.893,31.793a11.8,11.8,0,0,0-1.621,6.223l.277,8.651.21,2.761q1.119,14.1,2.337,16.891,1.332,3.056,4.671-3.1Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M149.19,120.574l-.227.255c-5.623,6.5-16.2,9-22.724,9.327L94.9,147.554l.07.882c.377,4.16,2.512,21.926,11.891,29.081,10.553,8.047,26.351.85,32.054-5.572l.881-1.015c5.049-5.769,8.357-8.084,19.654-9.48l.527-.063c12.257-1.452,22.175-10.874,23.576-18.788s-2.1-13.635-12.055-22.034c-7.237-4.618-16.658-6.19-22.308.009Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M149.19,120.574l-.227.255c-5.623,6.5-16.2,9-22.724,9.327L94.9,147.554l.07.882c.377,4.16,2.512,21.926,11.891,29.081,10.553,8.047,26.351.85,32.054-5.572l.881-1.015c5.049-5.769,8.357-8.084,19.654-9.48l.527-.063c12.257-1.452,22.175-10.874,23.576-18.788s-2.1-13.635-12.055-22.034c-7.237-4.618-16.658-6.19-22.308.009Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M127.071,118.781l-15.793.275v9.9l22.744,10.18C128.5,132.115,127.071,118.781,127.071,118.781Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M63.474,158.694l.668.285c4.42,1.861,29.865,12.148,49.7,11.116l3.14-.156c19.09-.918,23.2-.721,27.844-15.073,3.472-10.729-2.445-11.471-6.89-12.638-1.814-.477-3.27-2.711-3.918-3.088-2.236-1.3-6.5-5.691-11.372-8.1-4.754-2.354-15.613-3.717-20.921-3.782l-.388,0a36.267,36.267,0,0,1-20.723-6.368C65.906,127.981,64.037,144.55,63.474,158.694Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M104.205,163.035l-6.537,2.5-1.551.182c-3.554.439-12.309,1.652-16.635,3.4-5.507,2.23-16.2,9.531-20.664,10.73s-6.961.33-9.476.877c-2.026.442-3.83,3.423-4.49,4.622l-.265.5c-.8,1.292,1.249,4.6,2.519,4.659l.207.012c1.618.114,7.235.795,9.145-1.6a14.753,14.753,0,0,1,5.7-4.631l.217-.059c2.7-.676,23.993-4.553,27.764-5.967,8.088-3.031,21.554-4.216,27.653-5.341,3.6-.664,18.482-9.614,13.465-12.228C127.775,158.883,104.205,163.035,104.205,163.035Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M103.474,162.367l14.274,15.15,1.135-.415c4.6-1.72,21.631-8.493,22.592-14.735,1.112-7.221-17.968-8.455-27.535-4.848Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M157.8,148.288c1.064,6.281,9.824,0,7.665-2.7-1.282-1.058-1.655-5.094,5.5-7.016-9.163-4.263-3.429-14.533-10.326-13.013l-.962.219c-9.075,2.132-17.657,6.05-15.877,11.531a11.187,11.187,0,0,0,.786,1.789l-3.881,1.261q-2.425.789-6.807-1.3-1,4.724,1.723,7.107c1.029.9,4.705.562,7.749,2.9q1.227.942,1.778,4.743c.74-.951.6-2.849,4.2-4.368Q150.953,148.756,157.8,148.288Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M149.827,145.526a14.993,14.993,0,0,1-4.628-5.39l-.61-1.041-2.427.789c1.965,3.9,3.709,5.285,7.379,5.619Z",
    fill: "#eda977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M54.189,20.794l7.738,7.835,7.931-7.141q1.9-8.891,8.365-19.236a1.01,1.01,0,0,0-.106-1.211L77.927.83a1.048,1.048,0,0,0-1.48-.078L66.154,10.02A56.011,56.011,0,0,0,60.1,16.4l-1.432,1.77-.7-.778ZM.646,41.535l10.51,3.285,3.65-10.028q-2.495-8.743-1.645-20.912A1.01,1.01,0,0,0,12.5,12.86l-.266-.1a1.048,1.048,0,0,0-1.343.626L6.153,26.405A56,56,0,0,0,3.8,34.883l-.434,2.235-.984-.358Z",
    fill: "#4f4f4f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(153 35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M52.269.15l.457,0,.5.011h0l.6.024h0l.569.034h0l.621.049h0l.989.1.635.084h0l.237.035h0a30.547,30.547,0,0,1,16.269,7.85l-.007,0a30.627,30.627,0,0,1,9.4,17.542h-.006a31.013,31.013,0,0,1,.12,9.012l.015,0a30.067,30.067,0,0,1-1.566,6.37l-.011,0a30.66,30.66,0,0,1-54.017,7.009l.016-.01-.111-.161H26.96a30.362,30.362,0,0,1-3.174-5.941H23.8a30.455,30.455,0,0,1-2-8.028q-.1-.872-.141-1.76l-.024-.594-.01-.43q0-.277,0-.555A30.66,30.66,0,0,1,46.1.772l.84-.16h0L47,.6q.478-.084.961-.151l.591-.077h0L49.23.3h0l.233-.022h0l.474-.04h0l.925-.056h0l.431-.016h0L51.78.154h0Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M63.465,50.424a28.365,28.365,0,0,1-19.3-49.159A30.648,30.648,0,1,0,79.015,45.792,28.329,28.329,0,0,1,63.465,50.424Z",
    opacity: 0.066
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M102.479,27.132c-.472-4.054-8.944-6.713-21.684-7.528a32.374,32.374,0,0,1,1.33,4.311c7.014.643,11.389,2.059,11.646,4.161.257,2.166-4.011,4.59-11.132,6.842-1.137.365-2.359.708-3.646,1.072a190.546,190.546,0,0,1-26.724,4.869,203.264,203.264,0,0,1-23.593,1.458c-1.716,0-3.367-.043-4.912-.107C14.906,41.8,9.18,40.365,8.9,37.963c-.279-2.316,4.633-5.019,12.7-7.442a33.814,33.814,0,0,1,.365-4.461C8.386,29.877-.3,34.746.214,39.057c.536,4.568,11.239,8.172,26.724,9.094,1.609.086,3.282.15,5,.193a155.017,155.017,0,0,0,20.847-1.051,152.5,152.5,0,0,0,24.622-4.869c1.265-.365,2.488-.729,3.668-1.115C94.457,36.933,102.993,31.4,102.479,27.132Z",
    fill: "#ff7d85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(9 167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 20.208,
    cy: 20.208,
    r: 20.208,
    transform: "translate(0.048 0.016)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M40.032,16A20.209,20.209,0,1,0,1.408,27.488c3.232-.912,8.112-2.544,15.376-5.248C27.424,18.256,34.768,16.48,40.032,16Z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M20.256,40.432a20.2,20.2,0,0,0,18.432-11.92A75.276,75.276,0,0,1,28.48,27.456c-9.008-1.568-18.224,2.88-23.424,6.08A20.2,20.2,0,0,0,20.256,40.432Z",
    fill: "#cf0814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M.208,17.7A52.6,52.6,0,0,0,19.776,11.76c5.568-3.088,10-5.36,13.488-7.024A20.212,20.212,0,0,0,.208,17.7Z",
    fill: "#fd5e68"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 256,
    height: 256,
    transform: "translate(575 46)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/Forbidden.9fbe0470.svg";
export { ForwardRef as ReactComponent };